import { List, ListItem, ListItemText } from "@mui/material";
import { simpleAlert } from "components/CommonLib/CommonLib";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Popup from "../../components/Popup/Popup";

const AddressSearchModal = ({ isOpen, onClose, onSelect }) => {
  const storesDispatch = useDispatch();
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchAddress = async () => {
    if (!keyword.trim()) {
      simpleAlert(storesDispatch, "알림", "검색어를 입력하세요.");
      return;
    }

    setLoading(true);

    const confmKey = process.env.REACT_APP_JUSO_KEY;
    const currentPage = 1;
    const countPerPage = 10;

    try {
      const response = await fetch(
        `https://business.juso.go.kr/addrlink/addrLinkApi.do?` +
          `confmKey=${confmKey}&` +
          `currentPage=${currentPage}&` +
          `countPerPage=${countPerPage}&` +
          `keyword=${encodeURIComponent(keyword)}&` +
          `resultType=json`,
      );

      const data = await response.json();

      if (data.results.common.errorCode === "0") {
        setResults(data.results.juso);
      } else {
        simpleAlert(storesDispatch, "알림", data.results.common.errorMessage);
        setResults([]);
      }
    } catch (error) {
      console.log(error);
      simpleAlert(storesDispatch, "알림", "주소 검색 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (item) => {
    onSelect({
      zipNo: item.zipNo,
      roadAddr: item.roadAddr,
      jibunAddr: item.jibunAddr,
      roadAddrPart1: item.roadAddrPart1,
      roadAddrPart2: item.roadAddrPart2,
      engAddr: item.engAddr,
    });
    onClose();
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title="주소 검색"
      Content={
        <div style={{ width: "500px", height: "500px", padding: "20px" }}>
          {/* 검색 입력 */}
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
            <TextField
              fullWidth
              labelMarginRight="0px"
              placeholder="도로명 또는 지번 입력"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") searchAddress();
              }}
            />
            <NormalBtn name={loading ? "..." : "검색"} onClick={searchAddress} disabled={loading} />
          </div>

          {/* 검색 결과 */}
          <div style={{ height: "400px", overflow: "auto", border: "1px solid #ddd" }}>
            {results.length === 0 ? (
              <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                검색 결과가 없습니다.
              </div>
            ) : (
              <List>
                {results.map((item, index) => (
                  <ListItem
                    button
                    key={index}
                    onClick={() => handleSelect(item)}
                    style={{
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                    }}
                    hover="true"
                  >
                    <ListItemText
                      primary={item.roadAddr}
                      secondary={
                        <>
                          <div>지번: {item.jibunAddr}</div>
                          <div>우편번호: {item.zipNo}</div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </div>
        </div>
      }
    />
  );
};

export default AddressSearchModal;
